import type { Sort, Attributes } from 'stores/PaginationTypes';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

export const EVENT_PROCEDURES_STEPS_LIBRARY_LIST_ID = 'eventProceduresStepsLibraryList';

export const ATTRIBUTES: Attributes = [
  {
    id: 'title',
    title: 'Title',
    type: 'STRING',
    filterable: false,
  },
  {
    id: 'type',
    title: 'Action',
    type: 'STRING',
  },
];

export const listElements = {
  defaultLayout: {
    entityTableId: EVENT_PROCEDURES_STEPS_LIBRARY_LIST_ID,
    defaultPageSize: 10,
    defaultSort: { attributeId: 'title', direction: 'asc' } as Sort,
    defaultDisplayedAttributes: ['title', 'type'],
  },
  columnOrder: ['title', 'type'],
};

export const deserializeEventProcedureSteps = ({ page, per_page, total, count, event_procedure_steps }) => ({
  attributes: ATTRIBUTES,
  list: event_procedure_steps.map((step: EventProcedureStepAPIType) => ({
    ...step,
    type: step?.action?.config?.type,
  })),
  pagination: { total, page, per_page, count },
});
